if (!customElements.get('doa-mobile-purchase')) {
 customElements.define('doa-mobile-purchase', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort = new AbortController();
   this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
   this.native = this.root?.querySelector('.product-form__submit');
   this.button = this.querySelector('button');this.summary = this.querySelector('[data-purchase-summary]');
   if (!this.native) return;
   this.picker = this.root.querySelector('variant-radios,variant-selects');
   this.chosen = !this.picker || new URLSearchParams(location.search).has('variant');
   this.media = matchMedia('(max-width: 749px)');this.originalVisible = true;
   this.sync = () => {
    const busy = this.native.classList.contains('loading') || this.native.getAttribute('aria-disabled') === 'true';
    this.button.disabled = this.chosen && (this.native.disabled || busy);
    const text = !this.chosen ? this.dataset.choose : busy ? this.dataset.working : this.native.querySelector('span')?.textContent.trim();
    if (text && this.button.textContent !== text) this.button.textContent = text;
    const price = this.root.querySelector('.price:not(.hidden)');
    const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular')?.textContent.trim() || '';
    const selected = this.picker ? [...this.picker.querySelectorAll('input:checked,select')].map(input => input.value).join(' / ') : '';
    const description = [amount, this.chosen ? selected : ''].filter(Boolean).join(' · ');
    if (this.summary.textContent !== description) this.summary.textContent = description;
    this.hidden = !this.media.matches || this.originalVisible;
   };
   this.root.addEventListener('change', event => {
    if (event.target.closest('variant-radios,variant-selects')) this.chosen = true;
    this.sync();
   }, {signal:this.abort.signal});
   this.button.addEventListener('click', () => {
    if (!this.chosen) {
     this.picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
     const input = this.picker.querySelector('input:checked,select,input');input?.focus({preventScroll:true});return;
    }
    if (this.native.disabled || this.native.getAttribute('aria-disabled') === 'true') return;
    this.native.click();this.sync();
   }, {signal:this.abort.signal});
   this.observer = new MutationObserver(this.sync);
   this.observer.observe(this.native,{attributes:true,childList:true,subtree:true,characterData:true});
   const price = this.root.querySelector(`[id="price-${this.dataset.section}"]`);
   if (price) this.observer.observe(price,{attributes:true,childList:true,subtree:true,characterData:true});
   const errors = this.root.querySelector('.product-form__error-message-wrapper');
   if (errors) {
    this.errorObserver = new MutationObserver(() => {if (!errors.hidden) errors.scrollIntoView({block:'center',behavior:'smooth'});});
    this.errorObserver.observe(errors,{attributes:true,attributeFilter:['hidden']});
   }
   this.visibility = new IntersectionObserver(entries=>{this.originalVisible=entries[0].isIntersecting;this.sync();},{threshold:0});this.visibility.observe(this.native);
   this.media.addEventListener('change',this.sync,{signal:this.abort.signal});this.sync();
  }
  disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.errorObserver?.disconnect();this.visibility?.disconnect();}
 });
}
